import { Switch as S } from 'radix-ui';
import { type ReactNode, useId } from 'react';
import { cx } from '@/lib/cx';
import s from './Switch.module.css';

export function Switch({
  checked,
  onChange,
  label,
  disabled,
  className,
  ...aria
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: ReactNode;
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
}) {
  const id = useId();
  return (
    <span className={cx(s.row, className)}>
      <S.Root id={id} checked={checked} onCheckedChange={onChange} disabled={disabled} className={s.switch} {...aria}>
        <S.Thumb className={s.thumb} />
      </S.Root>
      {label && (
        <label htmlFor={id} className={s.label}>
          {label}
        </label>
      )}
    </span>
  );
}
